import React from 'react';
import { Skeleton } from 'antd';
import styles from './index.less';
import NavLabel from '@/components/NavLabel';

const NewBranchDrawerSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.leftPanel}>
        <NavLabel>
           <Skeleton.Input active size="small" style={{ width: 60 }} />
        </NavLabel>
        <div className={styles.branchSummary}>
          <Skeleton active paragraph={{ rows: 1 }} title={{ width: '80%' }} />
          <Skeleton.Input active size="small" style={{ width: '60%', marginTop: 8 }} />
        </div>
        <div className={styles.navSection}>
           <div className={styles.serviceNav}>
              <NavLabel>
                 <Skeleton.Input active size="small" style={{ width: 80 }} />
              </NavLabel>
              <div className={styles.servicesList}>
                 {[1, 2, 3, 4].map((i) => (
                    <div key={i} className={styles.serviceItem} style={{ border: '1px solid #f0f0f0' }}>
                      <Skeleton.Avatar active size="small" shape="square" />
                      <div style={{ flex: 1 }}>
                        <Skeleton active paragraph={{ rows: 0 }} title={{ width: '70%', margin: 0 }} />
                        <Skeleton active paragraph={{ rows: 0 }} title={{ width: '40%', margin: 0 }} />
                      </div>
                    </div>
                 ))}
              </div>
           </div>
        </div>
        <div className={styles.addServiceBtn}>
          <Skeleton.Button active block />
        </div>
      </div>
      <div className={styles.rightPanel}>
        <div className={styles.branchDetailsForm}>
          {/* Status Toggle Card Skeleton */}
          <div style={{ marginBottom: 24, padding: 16, border: '1px solid #f0f0f0', borderRadius: 2 }}>
             <Skeleton active paragraph={{ rows: 1 }} title={{ width: '40%' }} />
          </div>

          {/* Name Field Skeleton */}
          <div style={{ marginBottom: 24 }}>
             <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
             <Skeleton.Input active style={{ width: '100%' }} />
          </div>

          {/* Category Field Skeleton */}
          <div style={{ marginBottom: 24 }}>
             <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
             <Skeleton.Input active style={{ width: '100%' }} />
          </div>

          {/* Manager Field Skeleton */}
          <div style={{ marginBottom: 24 }}>
             <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
             <Skeleton.Input active style={{ width: '100%' }} />
          </div>

          {/* Lead Source Field Skeleton */}
          <div style={{ marginBottom: 32 }}>
             <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
             <Skeleton.Input active style={{ width: '100%' }} />
          </div>

          {/* Address & Location Divider Skeleton */}
          <div style={{ margin: '24px 0 12px 0', borderBottom: '1px solid #f0f0f0', paddingBottom: 12 }}>
             <Skeleton.Input active size="small" style={{ width: 150 }} />
          </div>

          {/* Map/Address Field Skeleton */}
          <div style={{ height: 200, background: '#f5f5f5', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
             <Skeleton.Avatar active size="large" shape="circle" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewBranchDrawerSkeleton;
